import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/cn";

export interface KeyValueItem {
  label: string;
  value: string;
  mono?: boolean;
  className?: string;
}

interface KeyValueGridProps {
  items: KeyValueItem[];
  columns?: 2 | 3 | 4;
  loading?: boolean;
  className?: string;
}

export function KeyValueGrid({ items, columns = 2, loading, className }: KeyValueGridProps) {
  const colClass =
    columns === 4
      ? "sm:grid-cols-2 lg:grid-cols-4"
      : columns === 3
        ? "sm:grid-cols-2 lg:grid-cols-3"
        : "sm:grid-cols-2";

  return (
    <dl className={cn("grid gap-4", colClass, className)}>
      {items.map((item) => (
        <div key={item.label} className={cn("flex flex-col gap-0.5", item.className)}>
          <dt className="text-[10px] font-semibold uppercase tracking-[0.16em] text-muted-foreground">
            {item.label}
          </dt>
          <dd className={cn("text-sm text-foreground", item.mono !== false && "font-mono mono-num")}>
            {loading ? <Skeleton className="h-5 w-28" /> : item.value || "—"}
          </dd>
        </div>
      ))}
    </dl>
  );
}
